var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-down_svg__clip0_2074_5442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.393 0l15.55 16.911L34.727.375 38 3.975 18.824 23.997 0 3.48 3.393 0z",
    fill: "#ED6725"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-down_svg__clip0_2074_5442"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 38 0)",
    d: "M0 0h38v24H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDM4IDI0IiBmaWxsPSJub25lIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yMDc0XzU0NDIpIj4KICAgICAgICA8cGF0aCBkPSJNMy4zOTI4NSAtMy4wMjU0NWUtMDZMMTguOTQyOSAxNi45MTExTDM0LjcyNjUgMC4zNzVMMzggMy45NzUwNEwxOC44MjM2IDIzLjk5NzFMLTcuOTM3OTVlLTA2IDMuNDgwMUwzLjM5Mjg1IC0zLjAyNTQ1ZS0wNloiIGZpbGw9IiNFRDY3MjUiLz4KICAgIDwvZz4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfMjA3NF81NDQyIj4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjM4IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgLTguNzQyMjhlLTA4IC04Ljg2NjI5ZS0wOCAxIDM4IDApIi8+CiAgICAgICAgPC9jbGlwUGF0aD4KICAgIDwvZGVmcz4KPC9zdmc+Cg==";
export { SvgArrowDown as ReactComponent };